import { api } from './client'

export interface Channel {
  id: string
  owner_id: string
  name: string
  description: string
  username: string
  avatar_file_id: string
  subscriber_count: number
  is_public: boolean
  allow_comments: boolean
  created_at: string
}

export interface ChannelPost {
  id: string
  channel_id: string
  author_id: string
  text: string
  media_ids?: string[]
  reactions?: { emoji: string; count: number; my_react: boolean }[]
  views_count: number
  is_pinned: boolean
  scheduled_at?: string
  created_at: string
  edited_at?: string
}

export const channelsApi = {
  create: (data: { name: string; description?: string; username?: string; is_public?: boolean }): Promise<Channel> =>
    api.post('/v1/channels/', data),

  get: (id: string): Promise<Channel> =>
    api.get(`/v1/channels/${id}`),

  update: (id: string, data: { name?: string; description?: string; is_public?: boolean; allow_comments?: boolean }): Promise<Channel> =>
    api.patch(`/v1/channels/${id}`, data),

  delete: (id: string): Promise<void> =>
    api.delete(`/v1/channels/${id}`),

  subscribe: (id: string): Promise<void> =>
    api.post(`/v1/channels/${id}/subscribe`, {}),

  unsubscribe: (id: string): Promise<void> =>
    api.delete(`/v1/channels/${id}/subscribe`),

  getSubscribers: (id: string): Promise<{ subscribers: { channel_id: string; user_id: string; role: string }[] }> =>
    api.get(`/v1/channels/${id}/subscribers`),

  listSubscriptions: (): Promise<{ channels: Channel[] }> =>
    api.get('/v1/channels/subscriptions'),

  createPost: (id: string, data: { text: string; media_ids?: string[] }): Promise<ChannelPost> =>
    api.post(`/v1/channels/${id}/posts`, data),

  getPosts: (id: string, beforeId?: string): Promise<{ posts: ChannelPost[]; next_cursor: string }> =>
    api.get(`/v1/channels/${id}/posts${beforeId ? `?before=${beforeId}` : ''}`),

  editPost: (channelId: string, postId: string, data: { text: string; media_ids?: string[] }): Promise<ChannelPost> =>
    api.patch(`/v1/channels/${channelId}/posts/${postId}`, data),

  deletePost: (channelId: string, postId: string): Promise<void> =>
    api.delete(`/v1/channels/${channelId}/posts/${postId}`),

  pinPost: (channelId: string, postId: string): Promise<void> =>
    api.post(`/v1/channels/${channelId}/posts/${postId}/pin`, {}),

  react: (channelId: string, postId: string, emoji: string): Promise<void> =>
    api.post(`/v1/channels/${channelId}/posts/${postId}/reactions`, { emoji }),

  unreact: (channelId: string, postId: string): Promise<void> =>
    api.delete(`/v1/channels/${channelId}/posts/${postId}/reactions`),
}
